import { render, staticRenderFns } from "./CreateNewService.vue?vue&type=template&id=5edab142&scoped=true&"
import script from "./CreateNewService.vue?vue&type=script&lang=js&"
export * from "./CreateNewService.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewService.vue?vue&type=style&index=0&id=5edab142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edab142",
  null
  
)

export default component.exports